import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiCreateSensor, apiResetUserDeviceGroups, apiUpdateSensor } from 'apis/SensorApi';
import RangeSlider from 'components/RangeSlider';
import { SCENARIO_MAX_ROTATION, SCENARIO_MIN_ROTATION, SENSOR_MAX_LAT, SENSOR_MAX_LNG, SENSOR_MIN_LAT, SENSOR_MIN_LNG, TARGET_ZOOM_CAMERA } from 'constants/config';
import { DIALOG_ERROR_GENERAL_ERROR_MESSAGE, DIALOG_ERROR_INVALID_GRAPH_GATE_OPENING_LEVEL, DIALOG_ERROR_INVALID_GRAPH_WATER_LEVEL, DIALOG_ERROR_INVALID_LAT, DIALOG_ERROR_INVALID_LNG, DIALOG_ERROR_USE_UPPERCASE_ELTRES_ID, DIALOG_MESSAGE_CREATED_SENSOR_SUCCESSFULLY, DIALOG_MESSAGE_UPDATED_SENSOR_SUCCESSFULLY, TEXT_MAX_OPENING_LEVEL, TEXT_MAX_WATER_LEVEL, TEXT_MIN_OPENING_LEVEL, TEXT_MIN_WATER_LEVEL, TEXT_BUTTON_CREATE, TEXT_BUTTON_UPDATE, TEXT_STREETLIGHT_HEIGHT, TEXT_CAMERA_FEATURE, TEXT_CANCEL, TEXT_DESCRIPTION, TEXT_ELTRES_ID, TEXT_ERROR_SENSOR_ALREADY_EXISTED, TEXT_FLOOD_GATE_OPENING_LEVEL_DISPLAY, TEXT_FLOOD_GATE_OPENING_UNIT, TEXT_GROUP_ID, TEXT_IP_ADDRESS, TEXT_LATITUDE, TEXT_LOCATION, TEXT_LONGITUDE, TEXT_MANAGEMENT_ID, TEXT_MESSAGE_GROUP, TEXT_NAME, TEXT_PASSWORD, TEXT_SENSOR_TYPE, TEXT_MANAGEMENT_AREA, TEXT_STORAGE_IMAGE_INTERVAL, TEXT_STORAGE_IMAGE_PERIOD, TEXT_TYPE_CAMERA, TEXT_USERNAME, TEXT_ZOOM_CENTER_COORDINATE_X, TEXT_ZOOM_CENTER_COORDINATE_Y, TEXT_ZOOM_IMAGE_FEATURE, TEXT_ZOOM_IMAGE_RATE, TEXT_SWAP_IMAGE_CAMERA, TEXT_TYPE_DISPLAY_CAMERA, TEXT_ZOOM_TARGET_CAMERA, TEXT_SD_CARD_RECORDING, TEXT_IMAGE_ANALYSIS_FEATURE, TEXT_IMAGE_ANALYSIS_SYSTEM_PROMPT, TEXT_IMAGE_ANALYSIS_USER_PROMPT, TEXT_TRAFFIC_VOLUME_FEATURE, TEXT_ACQUISITION_IMAGE_INTERVAL, DIALOG_MESSAGE_CONFIRM_WARNING_CHANGE_DIRECTIONS_MESSAGE, TEXT_OK, DIALOG_ERROR_INVALID_ROTATION } from 'constants/message';
import { useDialog } from 'context/DialogContext';
import { useSensorGroups } from 'context/SensorGroupsContext';
import { useSensors } from 'context/SensorsContext';
import { SensorType, SensorTypeName } from 'models';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DIRECTION_OPTIONS, SENSOR_PROPERTIES } from 'utils/constanst';
import "./ModifySensorForm.css";
import SensorPropertyInfoDialog from './SensorPropertyInfoDialog';
import Switch from 'components/Switch';
import ColorPickerInput from '../../components/ColorPickerInput';
import FanLoadingIcon from 'components/FanLoadingIcon';
import { useUserSensorGroups } from 'hooks/useUserSensorGroups';

const propTypes = {
  sensor: PropTypes.object,
  onModify: PropTypes.func,
  onCancel: PropTypes.func
};
const defaultProps = {
  sensor: {},
  onModify: (newSensor) => { },
  onCancel: () => { }
};

const {
  MANAGE_ID,
  NAME,
  LOCATION,
  GROUP_ID,
  ID,
  API_GROUP_ID,
  TYPE,
  MANAGEMENT_AREA,
  LAT,
  LONG,
  DESCRIPTION,
  STREETLIGHT_HEIGHT,
  // FLOOD GATE
  FLOOD_GATE_OPENING_UNIT,
  FLOOD_GATE_OPENING_LEVEL_DISPLAY,
  A,
  B,
  C,
  D,
  E,
  F,
  V0,
  G0,
  Wa,
  Wb,
  Wc,
  Wd,
  Wta,
  Wtb,
  Wtc,
  Wtd,
  Va0,
  Va1,
  Vb0,
  Vb1,
  Vc0,
  Vtc0,
  Vc1,
  Vtc1,
  Vd1,
  Vd2,
  Ve,
  MAX_WATER_LEVEL,
  MIN_WATER_LEVEL,
  MAX_OPENING_LEVEL,
  MIN_OPENING_LEVEL,
  // CAMERA
  TYPE_CAMERA,
  CAMERA_1_DIRECTION,
  CAMERA_2_DIRECTION,
  CAMERA_1_ROTATION,
  CAMERA_2_ROTATION,
  SWAP_IMAGE_CAMERA,
  TYPE_DISPLAY_CAMERA,
  ZOOM_TARGET_CAMERA,
  CAMERA_FEATURE,
  IP_ADDRESS,
  USERNAME,
  PASSWORD,
  ZOOM_IMAGE_FEATURE,
  ZOOM_IMAGE_RATE,
  ZOOM_CENTER_COORDINATE_X,
  ZOOM_CENTER_COORDINATE_Y,
  SD_CARD_RECORDING,
  TRAFFIC_VOLUME_FEATURE,
  TRAFFIC_VOLUME_COUNTABLE_CAMERA,
  TRAFFIC_VOLUME_RETRY_COUNT,
  TRAFFIC_VOLUME_NAME,
  TRAFFIC_VOLUME_TYPE,
  TRAFFIC_VOLUME_SCENARIO,
  TRAFFIC_VOLUME_STORAGE_PERIOD,
  TRAFFIC_VOLUME_LAT,
  TRAFFIC_VOLUME_LNG,
  TRAFFIC_VOLUME_ROTATION,
  TRAFFIC_VOLUME_ARROW_COLOR,
  IMAGE_ANALYSIS_FEATURE,
  IMAGE_ANALYSIS_EXECUTION_START_TIME,
  IMAGE_ANALYSIS_EXECUTION_END_TIME,
  IMAGE_ANALYSIS_WEATHER_ACQUISTION_INTERVAL,
  IMAGE_ANALYSIS_INTERVAL,
  IMAGE_ANALYSIS_SYSTEM_PROMPT,
  IMAGE_ANALYSIS_USER_PROMPT,
  IMAGE_ANALYSIS_ZOOM_FEATURE,
  IMAGE_ANALYSIS_ZOOM_START_TIME,
  IMAGE_ANALYSIS_ZOOM_END_TIME,
  IMAGE_ANALYSIS_ZOOM_RATE,
  IMAGE_ANALYSIS_ZOOM_CENTER_COORDINATE_X,
  IMAGE_ANALYSIS_ZOOM_CENTER_COORDINATE_Y,
  STORAGE_IMAGE_INTERVAL,
  STORAGE_IMAGE_PERIOD,
  ACQUISITION_IMAGE_INTERVAL,
  // GENERAL
  SOCKET_IP_ADDRESS,
  CONNECT_METHOD,
  NAME_SIGNAL,
  CONVERSION_FACTOR_SIGNAL,
  CORRECTION_COEFFICIENT_SIGNAL,
  UNIT_SIGNAL,
  DECIMAL_PART_LENGTH,
  ALARM_VALUE_SIGNAL,
  ALARM_VALUE_OPARETOR_SIGNAL,
  CAUTION_VALUE_SIGNAL,
  CAUTION_VALUE_OPARETOR_SIGNAL,
  ALARM_RETURN_THRESHOLD_SIGNAL,
  ALARM_RETURN_THRESHOLD_OPARETOR_SIGNAL,
  CAUTION_RETURN_THRESHOLD_SIGNAL,
  CAUTION_RETURN_THRESHOLD_OPARETOR_SIGNAL,
  ABNORMAL_VALUE_SIGNAL,
  ABNORMAL_VALUE_OPARETOR_SIGNAL,
  NUMERICAL_UPPER_LIMIT_SIGNAL,
  NUMERICAL_LOWER_LIMIT_SIGNAL,
  GRAPH_AXIS_SIGNAL,
  NAME_LEFT_Y,
  UPPER_LIMIT_LEFT_Y,
  LOWER_LIMIT_LEFT_Y,
  NAME_RIGHT_Y,
  UPPER_LIMIT_RIGHT_Y,
  LOWER_LIMIT_RIGHT_Y,
  NAME_CONTACT,
  VALUE_CONTACT,
  NAME_ALARM,
  LOGIC_ALARM,
  HISTORY_PERIOD,
} = SENSOR_PROPERTIES


const directionMap = {
  'NORTH': 'SOUTH',
  'NORTHEAST': 'SOUTHWEST',
  'EAST': 'WEST',
  'SOUTHEAST': 'NORTHWEST',
  'SOUTH': 'NORTH',
  'SOUTHWEST': 'NORTHEAST',
  'WEST': 'EAST',
  'NORTHWEST': 'SOUTHEAST',
  'INBOUND': 'OUTBOUND',
  'OUTBOUND': 'INBOUND',
};

const rotationMap = {
  'NORTH': { camera1: 0, camera2: 180 },
  'NORTHEAST': { camera1: 45, camera2: 225 },
  'EAST': { camera1: 90, camera2: 270 },
  'SOUTHEAST': { camera1: 135, camera2: 315 },
  'SOUTH': { camera1: 180, camera2: 0 },
  'SOUTHWEST': { camera1: 225, camera2: 45 },
  'WEST': { camera1: 270, camera2: 90 },
  'NORTHWEST': { camera1: 315, camera2: 135 },
  'INBOUND': { camera1: 0, camera2: 180 },
  'OUTBOUND': { camera1: 180, camera2: 0 },
}

const ModifySensorForm = (props) => {
  /*** States and Variables ***/
  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
    watch,
    setValue,
    reset,
    control,
    getValues
  } = useForm();
  const initSensor = props.sensor;
  const { sensorGroups } = useSensorGroups();
  const { sensors } = useSensors();
  const { error, success, warningConfirm } = useDialog();
  const groupNames = useUserSensorGroups();
  const [loading, setLoading] = React.useState(false);
  const [propertyDialogOpen, setPropertyDialogOpen] = React.useState(false);

  const targetGroup = sensorGroups.find(g => g.id === watch(GROUP_ID, initSensor.groupId));
  const groupIds = sensorGroups.map(group => group.id);
  const groupId = groupIds.includes(initSensor.groupId && initSensor.groupId) ? initSensor.groupId : null;

  const cameraFeature = watch(CAMERA_FEATURE, initSensor.data?.cameraFeature)
  const typeCamera = watch(TYPE_CAMERA);
  const camera1Direction = watch(CAMERA_1_DIRECTION);
  const camera1Rotation = watch(CAMERA_1_ROTATION);
  const refDetectModifyDirectionAndRotation = React.useRef(false);

  const handleAutoInputFromLatLng = async () => {
    const lat = getValues(LAT);
    const lng = getValues(LONG);
    const parsedLat = parseFloat(lat);
    const parsedLng = parseFloat(lng);

    if (isNaN(lat) || !isFinite(parsedLat) || isNaN(parsedLat) || parsedLat < SENSOR_MIN_LAT || parsedLat > SENSOR_MAX_LAT) {
      error(DIALOG_ERROR_INVALID_LAT);
      return;
    }
    if (isNaN(lng) || !isFinite(parsedLng) || isNaN(parsedLng) || parsedLng < SENSOR_MIN_LNG || parsedLng > SENSOR_MAX_LNG) {
      error(DIALOG_ERROR_INVALID_LNG);
      return;
    }

    setLoading(true);
    try {
      const apiUrl = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${parsedLat}&lon=${parsedLng}&addressdetails=1&accept-language=ja`;
      const response = await fetch(apiUrl);
      if (response.ok) {
        const geoData = await response.json();
        if (geoData.display_name) {
          const parts = geoData.display_name.split(', ');
          const addressParts = parts.filter(part => !/^\d{3}-\d{4}$/.test(part.trim()) && part.trim() !== '日本');
          const locationName = addressParts.reverse().slice(0, 4).join('');
          if (locationName) {
            setValue(LOCATION, locationName, { shouldDirty: true });
          } else {
            error("管理エリアの取得に失敗しました。");
          }
        } else {
          error("管理エリアの取得に失敗しました。");
        }
      } else {
        console.error("Không thể lấy thông tin địa chỉ từ Nominatim.");
        error("管理エリアの取得に失敗しました。");
      }
    } catch (e) {
      console.error("Lỗi khi lấy thông tin địa chỉ:", e);
      error("管理エリアの取得に失敗しました。");
    } finally {
      setLoading(false);
    }
  };

  /*** Processing ***/
  React.useEffect(() => {
    reset({
      id: initSensor.id?.split('+')[0],
      managementId: initSensor.managementId,
      name: initSensor.name,
      location: initSensor.location,
      groupId: groupId,
      apiGroupId: initSensor.apiGroupId,
      lat: initSensor.lat,
      lng: initSensor.lng,
      description: initSensor.description,
      data: initSensor.data || {}
    })
  }, [initSensor.id])

  React.useEffect(() => {
    if (targetGroup?.type === SensorType.CAMERA && !cameraFeature) {
      setValue(ZOOM_IMAGE_FEATURE, false)
      setValue(SD_CARD_RECORDING, false)
      setValue(IMAGE_ANALYSIS_FEATURE, false)
      setValue(TRAFFIC_VOLUME_FEATURE, false)
    }
  }, [cameraFeature, setValue, targetGroup?.type])

  React.useEffect(() => {
    if (targetGroup?.type === SensorType.CAMERA && typeCamera === 'SINGLE') {
      setValue(SWAP_IMAGE_CAMERA, false)
      setValue(ZOOM_TARGET_CAMERA, 'CAMERA1')
      setValue(TRAFFIC_VOLUME_COUNTABLE_CAMERA, 1)
    }
  }, [typeCamera, setValue, targetGroup?.type])

  React.useEffect(() => {
    // Check camera direction and rotation modification
    if (!refDetectModifyDirectionAndRotation.current) return;

    const angle = rotationMap[camera1Direction];
    // Check if camera1Direction is [選択してください]
    if (!angle) return;
    setValue(CAMERA_1_ROTATION, angle.camera1);
    if (typeCamera === 'DOUBLE') {
      const camera2Value = directionMap[camera1Direction];
      if (camera2Value && angle) {
        setValue(CAMERA_2_DIRECTION, camera2Value);
      }
    }
  }, [camera1Direction]);

  // Update camera 2 rotation when camera 1 rotation changes
  React.useEffect(() => {
    // Check camera direction and rotation modification
    if (!refDetectModifyDirectionAndRotation.current) return;

    if (isNaN(camera1Rotation)) {
      setValue(CAMERA_1_ROTATION, 0);
    }
    const newCamera1Rotation = Number(camera1Rotation);
    if (newCamera1Rotation === 360) {
      setValue(CAMERA_1_ROTATION, 0);
      return;
    }
    if (newCamera1Rotation === -1) {
      setValue(CAMERA_1_ROTATION, 359);
      return;
    }
    setValue(CAMERA_2_ROTATION, newCamera1Rotation + 180 >= 360 ? newCamera1Rotation - 180 : newCamera1Rotation + 180);
  }, [camera1Rotation]);


  const FORM_ITEMS = React.useMemo(() => {
    const defaultItems = [
      { name: MANAGE_ID, displayName: { text: TEXT_MANAGEMENT_ID }, type: 'text', required: true },
      { name: NAME, displayName: { text: TEXT_NAME }, type: 'text', required: true },
      { name: LOCATION, displayName: { text: TEXT_LOCATION }, type: 'text_with_button', buttonLabel: '緯度・経度から自動入力', onButtonClick: handleAutoInputFromLatLng, required: true },
      { name: GROUP_ID, displayName: { text: TEXT_MESSAGE_GROUP }, options: [{ label: 'グループを選択', value: '', disabled: true }, ...sensorGroups.map((item) => ({ label: item.name, value: item.id }))], required: true, type: 'select' },
      { name: ID, displayName: { text: TEXT_ELTRES_ID }, type: 'text', disabled: !!initSensor.id, required: true },
      { name: API_GROUP_ID, displayName: { text: TEXT_GROUP_ID }, type: 'text', required: true },
      { name: TYPE, displayName: { text: TEXT_SENSOR_TYPE }, type: 'text', value: targetGroup ? SensorTypeName[targetGroup.type] : '', disabled: true, required: true },
      { name: MANAGEMENT_AREA, displayName: { text: TEXT_MANAGEMENT_AREA }, type: 'text', required: false },
      { name: LAT, displayName: { text: TEXT_LATITUDE }, type: 'text', required: true },
      { name: LONG, displayName: { text: TEXT_LONGITUDE }, type: 'text', required: true },
      { name: DESCRIPTION, displayName: { text: TEXT_DESCRIPTION }, type: 'text', required: false },
    ]
    if (targetGroup?.type === SensorType.FLOOD_GATE) {
      return [
        ...defaultItems.slice(0, -1),
        { name: 'isSeparator0', isSeparator: true, displayName: { text: '' } },
        { name: FLOOD_GATE_OPENING_UNIT, displayName: { text: TEXT_FLOOD_GATE_OPENING_UNIT }, type: 'text', required: false },
        { name: FLOOD_GATE_OPENING_LEVEL_DISPLAY, displayName: { text: TEXT_FLOOD_GATE_OPENING_LEVEL_DISPLAY }, options: [{ label: '整数', value: 0 }, { label: '小数点以下２桁', value: 2 }], required: false, type: 'select' },
        { name: 'isSeparator1', isSeparator: true, hasIcon: true, displayName: { text: '川表水位パラメータ' } },
        { name: A, displayName: { text: 'A' }, type: 'number', required: true },
        { name: B, displayName: { text: 'B' }, type: 'number', required: true },
        { name: 'isSeparator2', isSeparator: true, hasIcon: true, displayName: { text: '川裏水位パラメータ' } },
        { name: C, displayName: { text: 'C' }, type: 'number', required: true },
        { name: D, displayName: { text: 'D' }, type: 'number', required: true },
        { name: 'isSeparator3', isSeparator: true, hasIcon: true, displayName: { text: '水門開度パラメータ' } },
        { name: E, displayName: { text: 'E' }, type: 'number', required: true },
        { name: F, displayName: { text: 'F' }, type: 'number', required: true },
        { name: V0, displayName: { text: 'V', small: '0' }, type: 'number', required: true },
        { name: 'isSeparator4', isSeparator: true, hasIcon: true, displayName: { text: '水門開度閾値' } },
        { name: G0, displayName: { text: 'G', small: '0' }, type: 'number', required: true },
        { name: 'isSeparator5', isSeparator: true, hasIcon: true, displayName: { text: '警報閾値' } },
        { name: Wa, displayName: { text: 'W', small: 'a' }, type: 'number', required: false },
        { name: Wb, displayName: { text: 'W', small: 'b' }, type: 'number', required: false },
        { name: Wc, displayName: { text: 'W', small: 'c' }, type: 'number', required: false },
        { name: Wd, displayName: { text: 'W', small: 'd' }, type: 'number', required: false },
        { name: 'isSeparator6', isSeparator: true, hasIcon: true, displayName: { text: '警報復旧値' } },
        { name: Wta, displayName: { text: "W'", small: 'a' }, type: 'number', required: false },
        { name: Wtb, displayName: { text: "W'", small: 'b' }, type: 'number', required: false },
        { name: Wtc, displayName: { text: "W'", small: 'c' }, type: 'number', required: false },
        { name: Wtd, displayName: { text: "W'", small: 'd' }, type: 'number', required: false },
        { name: 'isSeparator7', isSeparator: true, hasIcon: true, displayName: { text: '異常閾値' } },
        { name: Va0, displayName: { text: 'V', small: 'a0' }, type: 'number', required: true },
        { name: Va1, displayName: { text: 'V', small: 'a1' }, type: 'number', required: true },
        { name: Vb0, displayName: { text: 'V', small: 'b0' }, type: 'number', required: true },
        { name: Vb1, displayName: { text: 'V', small: 'b1' }, type: 'number', required: true },
        { name: Vc0, displayName: { text: 'V', small: 'c0' }, type: 'number', required: true },
        { name: Vtc0, displayName: { text: "V'", small: 'c0' }, type: 'number', required: true },
        { name: Vc1, displayName: { text: 'V', small: 'c1' }, type: 'number', required: true },
        { name: Vtc1, displayName: { text: "V'", small: 'c1' }, type: 'number', required: true },
        { name: Vd1, displayName: { text: 'V', small: 'd1' }, type: 'number', required: true },
        { name: Vd2, displayName: { text: 'V', small: 'd2' }, type: 'number', required: true },
        { name: Ve, displayName: { text: 'V', small: 'e' }, type: 'number', required: true },
        { name: 'isSeparator7', isSeparator: true, displayName: { text: 'グラフ表示' } },
        { name: MAX_WATER_LEVEL, displayName: { text: TEXT_MAX_WATER_LEVEL }, type: 'number', required: false },
        { name: MIN_WATER_LEVEL, displayName: { text: TEXT_MIN_WATER_LEVEL }, type: 'number', required: false },
        { name: MAX_OPENING_LEVEL, displayName: { text: TEXT_MAX_OPENING_LEVEL }, type: 'number', required: false },
        { name: MIN_OPENING_LEVEL, displayName: { text: TEXT_MIN_OPENING_LEVEL }, type: 'number', required: false },
        { name: 'isSeparator8', isSeparator: true, displayName: { text: '' } },
        ...defaultItems.slice(-1),
      ]
    }
    if (targetGroup?.type === SensorType.CAMERA) {
      const CAMERA_ITEMS = defaultItems.filter(item => item.name !== API_GROUP_ID && item.name !== ID)
      return [
        ...CAMERA_ITEMS.slice(0, 5),
        { name: TYPE_CAMERA, displayName: { text: TEXT_TYPE_CAMERA }, type: 'select', options: [{ label: 'シングルカメラ', value: 'SINGLE' }, { label: 'ダブルカメラ', value: 'DOUBLE' }], required: true },
        { name: CAMERA_1_DIRECTION, displayName: { text: 'カメラ1方向' }, type: 'select_with_input', options: DIRECTION_OPTIONS, required: false, inputName: CAMERA_1_ROTATION },
        { name: CAMERA_2_DIRECTION, displayName: { text: 'カメラ2方向' }, type: 'select_with_input', options: DIRECTION_OPTIONS, required: false, dependsOn: { name: TYPE_CAMERA, value: "DOUBLE" }, inputName: CAMERA_2_ROTATION },
        { name: TYPE_DISPLAY_CAMERA, displayName: { text: TEXT_TYPE_DISPLAY_CAMERA }, type: 'select', options: [{ label: '静止画', value: 'IMAGE' }, { label: '動画', value: 'VIDEO' }] },
        { name: SWAP_IMAGE_CAMERA, displayName: { text: TEXT_SWAP_IMAGE_CAMERA }, type: 'checkbox', required: false, dependsOn: { name: TYPE_CAMERA, value: "DOUBLE" } },
        ...CAMERA_ITEMS.slice(5, 8),
        { name: STREETLIGHT_HEIGHT, displayName: { text: TEXT_STREETLIGHT_HEIGHT }, type: 'number', step: '0.1', required: false },
        { name: CAMERA_FEATURE, displayName: { text: TEXT_CAMERA_FEATURE }, type: 'checkbox', required: false },
        { name: IP_ADDRESS, displayName: { text: TEXT_IP_ADDRESS }, type: 'text', required: true, dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: USERNAME, displayName: { text: TEXT_USERNAME }, type: 'text', required: true, dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: PASSWORD, displayName: { text: TEXT_PASSWORD }, type: 'password', required: true, dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: ZOOM_IMAGE_FEATURE, displayName: { text: TEXT_ZOOM_IMAGE_FEATURE }, type: 'checkbox', required: false, dependsOn: [{ name: CAMERA_FEATURE, value: true }] },
        { name: ZOOM_TARGET_CAMERA, displayName: { text: TEXT_ZOOM_TARGET_CAMERA }, type: 'select', options: [{ label: 'カメラ1', value: TARGET_ZOOM_CAMERA.CAMERA1 }, { label: 'カメラ2', value: TARGET_ZOOM_CAMERA.CAMERA2 }], defaultValue: TARGET_ZOOM_CAMERA.CAMERA1, required: true, dependsOn: [{ name: TYPE_CAMERA, value: "DOUBLE" }, {name: ZOOM_IMAGE_FEATURE, value: true}] },
        { name: ZOOM_IMAGE_RATE, displayName: { text: TEXT_ZOOM_IMAGE_RATE }, type: 'range', min: 100, max: 1000, step: 1, required: true, dependsOn: [{ name: ZOOM_IMAGE_FEATURE, value: true }]},
        { name: ZOOM_CENTER_COORDINATE_X, displayName: { text: TEXT_ZOOM_CENTER_COORDINATE_X }, type: 'number', min: 0, max: 100, required: true, dependsOn: [{ name: ZOOM_IMAGE_FEATURE, value: true }] },
        { name: ZOOM_CENTER_COORDINATE_Y, displayName: { text: TEXT_ZOOM_CENTER_COORDINATE_Y }, type: 'number', min: 0, max: 100, required: true, dependsOn: [{ name: ZOOM_IMAGE_FEATURE, value: true }] },
        { name: SD_CARD_RECORDING, displayName: { text: TEXT_SD_CARD_RECORDING }, type: 'checkbox', required: false, dependsOn: { name: CAMERA_FEATURE, value: true } },
        // { name: IMAGE_ANALYSIS_FEATURE, displayName: { text: TEXT_IMAGE_ANALYSIS_FEATURE }, type: 'checkbox', required: false, dependsOn: { name: CAMERA_FEATURE, value: true } },
        {
          name: `画像解析実行期間`, displayName: { text: '画像解析実行期間' }, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }], childrens: [
            { name: IMAGE_ANALYSIS_EXECUTION_START_TIME, displayName: { rightText: '〜' }, type: 'date', required: true, style: { width: 140 } },
            { name: IMAGE_ANALYSIS_EXECUTION_END_TIME, displayName: { text: '' }, type: 'date', required: true, style: { width: 140 } },
          ]
        },
        { name: IMAGE_ANALYSIS_WEATHER_ACQUISTION_INTERVAL, displayName: { text: '天気情報取得間隔(分)' }, type: 'number', dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }], defaultValue: 1440, min: 0, max: 1440, required: true, },
        ...[1, 2].reduce((acc, i) => ([
          ...acc,
          { name: `isSeparator${i}`, isSeparator: true, displayName: { text: `画像解析${i}` }, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }] },
          { name: `${IMAGE_ANALYSIS_INTERVAL}${i}`, displayName: { text: '画像解析間隔(分)' }, type: 'number', dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }], defaultValue: i === 1 ? 60 : 1, min: 1, max: 60, required: true, },
          { name: `isSeparator${i}`, isSeparator: true, displayName: { text: `入力プロンプト` }, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }] },
          { name: `${IMAGE_ANALYSIS_SYSTEM_PROMPT}${i}`, displayName: { text: TEXT_IMAGE_ANALYSIS_SYSTEM_PROMPT }, type: 'textarea', style: { width: '320px' }, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }] },
          { name: `${IMAGE_ANALYSIS_USER_PROMPT}${i}`, displayName: { text: TEXT_IMAGE_ANALYSIS_USER_PROMPT }, type: 'textarea', style: { width: '320px' }, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }] },
        ]), []),
        { name: IMAGE_ANALYSIS_ZOOM_FEATURE, displayName: { text: '画像トリミング設定' }, type: 'checkbox', required: false, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }] },
        {
          name: `画像トリミング設定`, displayName: { text: '画像トリミング設定' }, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }, { name: IMAGE_ANALYSIS_ZOOM_FEATURE, value: true }], required: true, childrens: [
            { name: IMAGE_ANALYSIS_ZOOM_START_TIME, displayName: { rightText: '〜' }, type: 'time', required: true, style: { width: 140 } },
            { name: IMAGE_ANALYSIS_ZOOM_END_TIME, displayName: { text: '' }, type: 'time', required: true, style: { width: 140 } },
          ]
        },
        { name: IMAGE_ANALYSIS_ZOOM_RATE, displayName: { text: '拡大率' }, type: 'range', min: 100, max: 1000, step: 1, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }, { name: IMAGE_ANALYSIS_ZOOM_FEATURE, value: true }] },
        { name: IMAGE_ANALYSIS_ZOOM_CENTER_COORDINATE_X, displayName: { text: '拡大図の中心x座標(%)' }, type: 'number', min: 0, max: 100, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }, { name: IMAGE_ANALYSIS_ZOOM_FEATURE, value: true }] },
        { name: IMAGE_ANALYSIS_ZOOM_CENTER_COORDINATE_Y, displayName: { text: '拡大図の中心y座標(%)' }, type: 'number', min: 0, max: 100, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: IMAGE_ANALYSIS_FEATURE, value: true }, { name: IMAGE_ANALYSIS_ZOOM_FEATURE, value: true }] },
        { name: `isSeparator`, isSeparator: true, displayName: { text: `` }, dependsOn: { name: IMAGE_ANALYSIS_FEATURE, value: true } },
        { name: TRAFFIC_VOLUME_FEATURE, displayName: { text: TEXT_TRAFFIC_VOLUME_FEATURE }, type: 'checkbox', dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: TRAFFIC_VOLUME_COUNTABLE_CAMERA, displayName: { text: "カウント対象カメラ" }, type: 'select', options: typeCamera === 'SINGLE' ? [{ label: 'カメラ1', value: 1 }] : [{ label: 'カメラ1', value: 1 }, { label: 'カメラ2', value: 2 }], defaultValue: 1, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },
        { name: TRAFFIC_VOLUME_RETRY_COUNT, displayName: { text: "リトライ回数" }, type: 'select', options: Array.from({ length: 10 }, (_, i) => ({ label: i + 1, value: i + 1 })), defaultValue: 10, required: true, dependsOn: [{ name: CAMERA_FEATURE, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },
        ...Array.from({ length: 10 }, (_, i) => i + 1).reduce((acc, index) => (
          [
            ...acc,
            { name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, displayName: { text: `シナリオ${index}` }, type: 'checkbox', dependsOn: { name: TRAFFIC_VOLUME_FEATURE, value: true } },
            { name: `${TRAFFIC_VOLUME_NAME}${index}`, displayName: { text: 'カウント名称' }, type: 'text', dependsOn: [{ name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }], required: true },
            { name: `${TRAFFIC_VOLUME_TYPE}${index}`, displayName: { text: '種別' }, type: 'select', options: [{ label: '自動車', value: "VEHICLE" }, { label: '歩行者', value: "HUMAN" }], dependsOn: [{ name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },
            { name: `${TRAFFIC_VOLUME_LAT}${index}`, displayName: { text: '緯度' }, type: 'number', required: true, dependsOn: [{ name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },
            { name: `${TRAFFIC_VOLUME_LNG}${index}`, displayName: { text: '経度' }, type: 'number', required: true, dependsOn: [{ name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },
            { name: `${TRAFFIC_VOLUME_ROTATION}${index}`, displayName: { text: '回転角' }, type: 'number', required: true, step: '1', min: 0, max: 359, dependsOn: [{ name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },

            { name: `${TRAFFIC_VOLUME_STORAGE_PERIOD}${index}`, displayName: { text: `カウント情報保存期間` }, type: 'number', min: 1, max: 9999, defaultValue: 500, required: true, dependsOn: [{ name: `${TRAFFIC_VOLUME_SCENARIO}${index}`, value: true }, { name: TRAFFIC_VOLUME_FEATURE, value: true }] },
          ]
        ), []),
        { name: `isSeparator`, isSeparator: true, displayName: { text: `` }, dependsOn: { name: TRAFFIC_VOLUME_FEATURE, value: true } },
        { name: ACQUISITION_IMAGE_INTERVAL, displayName: { text: TEXT_ACQUISITION_IMAGE_INTERVAL }, type: 'number', defaultValue: 600, min: 30, max: 3600, required: true, dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: STORAGE_IMAGE_INTERVAL, displayName: { text: TEXT_STORAGE_IMAGE_INTERVAL }, type: 'number', defaultValue: 600, min: 30, max: 3600, required: true, dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: STORAGE_IMAGE_PERIOD, displayName: { text: TEXT_STORAGE_IMAGE_PERIOD }, type: 'number', defaultValue: 14, min: 1, max: 90, required: false, dependsOn: { name: CAMERA_FEATURE, value: true } },
        { name: 'isSeparator', isSeparator: true, displayName: { text: '' } },
        ...defaultItems.slice(-1),
      ]
    }
    if (targetGroup?.type === SensorType.GENERAL)
      return [
        ...defaultItems.slice(0, 4),
        { name: ID, displayName: { text: TEXT_ELTRES_ID }, type: 'text', disabled: !!initSensor.id, required: true, dependsOn: { name: CONNECT_METHOD, neValue: 'SOCKET' } },
        { name: API_GROUP_ID, displayName: { text: TEXT_GROUP_ID }, type: 'text', required: true, dependsOn: { name: CONNECT_METHOD, neValue: 'SOCKET' } },
        { name: SOCKET_IP_ADDRESS, displayName: { text: 'IPアドレス' }, type: 'text', required: false, dependsOn: { name: CONNECT_METHOD, value: 'SOCKET' } },
        ...defaultItems.slice(6, -1),
        { name: 'isSeparator10', isSeparator: true, displayName: { text: '' } },
        { name: CONNECT_METHOD, displayName: { text: '通信方式' }, type: 'select', options: [{ label: 'API', value: 'API' }, { label: 'ソケット通信', value: 'SOCKET' }], defaultValue: 'API', required: true },
        ...[0, 1, 2, 3, 4].reduce((acc, _, index) => {
          const defaultItems = [
            { name: `アナログ信号.isSeparator${11 + index}`, isSeparator: true, displayName: { text: `アナログ信号A${1 + 2 * index}` }, },
            { name: `${NAME_SIGNAL}${4 - index}`, displayName: { text: '表示名' }, type: 'text' },
            {
              name: `A${4 - index}換算値`, displayName: { text: `A${1 + 2 * index}換算値` }, childrens: [
                { name: `${CONVERSION_FACTOR_SIGNAL}${4 - index}`, displayName: { aboveText: '換算係数', leftText: '', rightText: `x A${1 + 2 * index}` }, type: 'number', style: { width: 160 } },
                { name: `${CORRECTION_COEFFICIENT_SIGNAL}${4 - index}`, displayName: { aboveText: 'ゼロ点補正係数', leftText: '+' }, type: 'number', style: { width: 160 } },
                { name: `${UNIT_SIGNAL}${4 - index}`, displayName: { aboveText: '単位', leftText: '[', rightText: ']' }, type: 'text', style: { width: 100 } },
              ]
            },
            {
              name: `${DECIMAL_PART_LENGTH}${4 - index}`, displayName: { text: '有効表示桁数' }, type: 'select', options: [0, 1, 2, 3, 4, 5].reduce((acc, _, index) => (
                [...acc, { label: index, value: index }]
              ), []), defaultValue: 0
            },
            {
              name: `警報設定値${4 - index}`, displayName: { text: '警報設定値' }, childrens: [
                { name: `${ALARM_VALUE_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'number', step: 'any' },
                { name: `${ALARM_VALUE_OPARETOR_SIGNAL}${4 - index}`, displayName: { rightText: `A${1 + 2 * index}換算値の場合は警報フラグON` }, type: 'select', options: [{ label: '≧', value: ">=" }, { label: '≦', value: "<=" }], defaultValue: ">=", style: { width: 50 } }
              ]
            },
            {
              name: `異常設定値${4 - index}`, displayName: { text: '異常設定値' }, childrens: [
                { name: `${ABNORMAL_VALUE_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'number' },
                { name: `${ABNORMAL_VALUE_OPARETOR_SIGNAL}${4 - index}`, displayName: { rightText: `A${1 + 2 * index}換算値の場合は異常` }, type: 'select', options: [{ label: '≧', value: ">=" }, { label: '≦', value: "<=" }], defaultValue: ">=", style: { width: 50 } }
              ]
            },
            { name: `${NUMERICAL_UPPER_LIMIT_SIGNAL}${4 - index}`, displayName: { text: '数値表示上限' }, type: 'number' },
            { name: `${NUMERICAL_LOWER_LIMIT_SIGNAL}${4 - index}`, displayName: { text: '数値表示下限' }, type: 'number' },
            { name: `${GRAPH_AXIS_SIGNAL}${4 - index}`, displayName: { text: `グラフ軸` }, type: 'select', options: [{ label: '主軸', value: 1 }, { label: '第2軸', value: 0 }], defaultValue: 1 },
            { name: `isSeparator${11 + index}`, isSeparator: true, displayName: { text: '' } },
          ]
          if (index === 0) {
            return [
              ...acc,
              ...defaultItems.slice(0, 5),
              {
                name: `注意設定値${4 - index}`, displayName: { text: '注意設定値' }, dependsOn: [{ name: CONNECT_METHOD, value: 'SOCKET' }], childrens: [
                  { name: `${CAUTION_VALUE_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'number', step: 'any' },
                  { name: `${CAUTION_VALUE_OPARETOR_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'select', options: [{ label: '≧', value: ">=" }, { label: '≦', value: "<=" }], defaultValue: ">=", style: { width: 50 } }
                ]
              },
              {
                name: `警報解除閾値${4 - index}`, displayName: { text: '警報解除閾値' }, dependsOn: [{ name: CONNECT_METHOD, value: 'SOCKET' }], childrens: [
                  { name: `${ALARM_RETURN_THRESHOLD_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'number', step: 'any' },
                  { name: `${ALARM_RETURN_THRESHOLD_OPARETOR_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'select', options: [{ label: '≧', value: ">=" }, { label: '≦', value: "<=" }], defaultValue: ">=", style: { width: 50 } }
                ]
              },
              {
                name: `注意解除閾値${4 - index}`, displayName: { text: '注意解除閾値' }, dependsOn: [{ name: CONNECT_METHOD, value: 'SOCKET' }], childrens: [
                  { name: `${CAUTION_RETURN_THRESHOLD_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'number', step: 'any' },
                  { name: `${CAUTION_RETURN_THRESHOLD_OPARETOR_SIGNAL}${4 - index}`, displayName: { text: '' }, type: 'select', options: [{ label: '≧', value: ">=" }, { label: '≦', value: "<=" }], defaultValue: ">=", style: { width: 50 } }
                ]
              },
              ...defaultItems.slice(5)
            ]
          }
          return [...acc, ...defaultItems]
        }, []),
        { name: `isSeparator15`, isSeparator: true, displayName: { text: `グラフ表示` } },
        { name: NAME_LEFT_Y, displayName: { text: `主軸名称` }, type: 'text' },
        { name: UPPER_LIMIT_LEFT_Y, displayName: { text: `主軸表示上限` }, type: 'number' },
        { name: LOWER_LIMIT_LEFT_Y, displayName: { text: `主軸表示下限` }, type: 'number' },
        { name: NAME_RIGHT_Y, displayName: { text: `第2軸名称` }, type: 'text' },
        { name: UPPER_LIMIT_RIGHT_Y, displayName: { text: `第2軸表示上限` }, type: 'number' },
        { name: LOWER_LIMIT_RIGHT_Y, displayName: { text: `第2軸表示下限` }, type: 'number' },
        { name: `isSeparator16`, isSeparator: true, displayName: { text: `` } },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].reduce((acc, _, index) => (
          [
            ...acc,
            { name: `isSeparator${17 + index}`, isSeparator: true, displayName: { text: `接点B${1 + index}` } },
            { name: `${NAME_CONTACT}${9 - index}`, displayName: { text: '表示名' }, type: 'text', defaultValue: '' },
            { name: `${VALUE_CONTACT}${9 - index}`, displayName: { text: '信号区分' }, type: 'select', options: [{ label: '通知', value: 1 }, { label: '異常検知', value: 0 }], defaultValue: 1 },
            { name: 'sep2', isSeparator: true, displayName: { text: '' } },
          ]
        ), []),
        { name: `isSeparator27`, isSeparator: true, displayName: { text: '警報設定' } },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].reduce((acc, _, index) => (
          [
            ...acc,
            { name: `isSeparator${28 + index}`, isSeparator: true, displayName: { text: `警報${index + 1}` } },
            { name: `${NAME_ALARM}${index + 1}`, displayName: { text: '表示名' }, type: 'text' },
            {
              name: `論理式${index + 1}`, displayName: { text: '論理式' }, childrens: [
                ...[1, 2, 3, 4, 5].map((i) => (
                  {
                    name: `${LOGIC_ALARM}${index + 1}_${i}`, displayName: { rightText: i === 5 ? '' : `&` }, style: { width: 100 }, type: 'select', options: [
                      { label: 'なし', value: '' },
                      ...[0, 1, 2, 3, 4].map((i) => ({ label: `A${9 - 2 * i}`, value: `a${i}` })),
                      ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({ label: `B${i + 1}`, value: `s${i}` })),
                    ]
                  }
                ))
              ],
            },
            { name: 'isSeparator38', isSeparator: true, displayName: { text: '' } },
          ]
        ), []),
        {
          name: HISTORY_PERIOD, displayName: { text: 'ログ表示期間' }, required: true, childrens: [
            { name: HISTORY_PERIOD, displayName: { rightText: '以降のログのみ表示' }, type: 'date', defaultValue: new Date().toISOString().split('T')[0] }
          ]
        },
        ...defaultItems.slice(-1),
      ]
    return defaultItems
  }, [initSensor, sensorGroups, targetGroup, groupNames])

  /*** Sub Components ***/
  const renderItemValue = ({ isSeparator, type, name, displayName, required, childrens, options, dependsOn, ...props }) => {
    if (isSeparator) return null;
    if (childrens) {
      return <div className='modify_sensor_form_item_childrens'>
        {childrens.map(item => (
          <div key={item.name} className='modify_sensor_form_item_children'>
            {item.displayName.aboveText && <label>{item.displayName.aboveText}</label>}
            <div className='modify_sensor_form_item_children_line'>
              {item.displayName.leftText && <label>{item.displayName.leftText}</label>}
              {renderItemValue(item)}
              {item.displayName.rightText && <label>{item.displayName.rightText}</label>}
            </div>
          </div>
        ))}
      </div>
    }

    if (name.includes(TRAFFIC_VOLUME_ROTATION)) {
      return <div className='modify_sensor_form_item_value'>
        <input
          type="number"
          {...register(name, {
            required,
            valueAsNumber: true,
          })}
          {...props}
          onKeyDown={e => {
            const currentValue = Number(e.target.value) || 0;
            if (e.key === 'ArrowUp' && currentValue === 359) {
              e.preventDefault();
              setValue(name, 0);
            }
            if (e.key === 'ArrowDown' && currentValue === 0) {
              e.preventDefault();
              setValue(name, 359);
            }
          }}
          onKeyUp={e => {
            const value = Number(e.target.value);
            if (value > 359) setValue(name, 359);
            if (value < 0) setValue(name, 0);
          }}
          {...props}
        />
      </div>
    }

    if (type === 'select') {
      return <select
        className='modify_sensor_form_group_select'
        {...register(name, { required })}
        defaultValue={props.defaultValue}
        {...props}
      >
        {options.map((item) => (
          <option key={item.value} value={item.value} disabled={item.disabled}>{item.label}</option>
        ))}
      </select>;
    }

    if (type === 'color-picker') {
      return (
        <Controller
          name={name}
          control={control}
          defaultValue={props.defaultValue}
          render={({ field }) => <ColorPickerInput {...field} />}
        />
      );
    }

    if (type === 'text_with_button') {
      const { buttonLabel, onButtonClick, ...inputProps } = props;
      return (
        <div className='modify_sensor_form_item_with_button'>
          <input type='text' {...register(name, { required })} {...inputProps} />
          <button type="button" onClick={onButtonClick} className='modify_sensor_form_auto_button'>
            {buttonLabel}
          </button>
        </div>
      );
    }

    if (type === 'checkbox') {
      return <div className='modify_sensor_form_item_value'>
        <Controller
          control={control}
          name={name}
          render={({ field }) => {
            return <Switch {...field} />
          }}
        />
      </div>
    }
    if (type === 'range') {
      return <div className='modify_sensor_form_item_value'>
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <RangeSlider
              min={props.min}
              max={props.max}
              step={props.step}
              progress={((field.value ?? props.min) - props.min) / (props.max - props.min)}
              {...field}
              value={field.value ?? props.min}
            />
          )}
        />
      </div>
    }
    if (type === 'textarea') {
      return <textarea {...register(name, { required })} {...props} rows={4} />
    }
    if (name === TYPE) {
      return <div className='modify_sensor_form_item_value'>
        <input type={type} {...props} />
      </div>
    }
    if (name === STORAGE_IMAGE_INTERVAL) {
      return <div className='modify_sensor_form_item_value'>
        <input
          type="number"
          {...register(name, {
            required: "画像保存間隔(秒)を設定していません。",
            valueAsNumber: true,
            validate: (value) => {
              const storageImageInterval = Number(value);
              const acquisitionImageInterval = Number(watch(ACQUISITION_IMAGE_INTERVAL));
              if (isNaN(storageImageInterval) || isNaN(acquisitionImageInterval)) return true;
              if (storageImageInterval < acquisitionImageInterval) return '画像保存間隔>画像取得間隔にしてください。';
              if (storageImageInterval % acquisitionImageInterval !== 0) return '画像保存間隔は、画像取得間隔の倍数にしてください。';
              return true;
            },
          })}
          {...props}
        />
      </div>
    }
    if (name === `${ALARM_VALUE_SIGNAL}4`) {
      return <div className='modify_sensor_form_item_value'>
        <input
          type="number"
          {...register(name, {
            valueAsNumber: true,
            validate: (value) => {
              const alarmValue = Number(value);
              const cautionValue = Number(watch(`${CAUTION_VALUE_SIGNAL}4`));
              const alarmReturnThreshold = Number(watch(`${ALARM_RETURN_THRESHOLD_SIGNAL}4`));
              const cautionReturnThreshold = Number(watch(`${CAUTION_RETURN_THRESHOLD_SIGNAL}4`));
              if (alarmValue < cautionValue) return '警報設定値>注意設定値に設定してください。';
              if (alarmValue < alarmReturnThreshold) return '警報設定値>警報解除閾値に設定してください。';
              if (alarmValue < cautionReturnThreshold) return '警報設定値>注意解除閾値に設定してください。';
              return true;
            },
          })}
          {...props}
        />
      </div>
    }
    if (name === `${ALARM_RETURN_THRESHOLD_SIGNAL}4`) {
      return <div className='modify_sensor_form_item_value'>
        <input
          type="number"
          {...register(name, {
            valueAsNumber: true,
            validate: (value) => {
              const alarmReturnThreshold = Number(value);
              const cautionValue = Number(watch(`${CAUTION_VALUE_SIGNAL}4`));
              const cautionReturnThreshold = Number(watch(`${CAUTION_RETURN_THRESHOLD_SIGNAL}4`));
              if (alarmReturnThreshold < cautionValue) return '警報解除閾値>注意設定値に設定してください。';
              if (alarmReturnThreshold < cautionReturnThreshold) return '警報解除閾値>注意解除閾値に設定してください。';
              return true;
            },
          })}
          {...props}
        />
      </div>
    }
    if (name === `${CAUTION_VALUE_SIGNAL}4`) {
      return <div className='modify_sensor_form_item_value'>
        <input
          type="number"
          {...register(name, {
            valueAsNumber: true,
            validate: (value) => {
              const cautionValue = Number(watch(`${CAUTION_VALUE_SIGNAL}4`));
              const cautionReturnThreshold = Number(watch(`${CAUTION_RETURN_THRESHOLD_SIGNAL}4`));
              if (cautionValue < cautionReturnThreshold) return '注意設定値>注意解除閾値に設定してください。';
              return true;
            },
          })}
          {...props}
        />
      </div>
    }
    if (type === 'select_with_input') {
      const { onChange: selectOnChange, ...selectProps } = register(name, { required });
      const { onChange: inputOnChange, ...inputProps } = register(props.inputName, {
        required,
        valueAsNumber: true,
      });

      return <div className='modify_sensor_form_select_with_input'>
        <select
          className='modify_sensor_form_group_select'
          {...selectProps}
          defaultValue={props.defaultValue}
          onChange={e => {
            if (!refDetectModifyDirectionAndRotation.current)
              refDetectModifyDirectionAndRotation.current = true;
            selectOnChange(e); // Call the original onChange
          }}
        >
          {options.map((item) => (
            <option key={item.value} value={item.value} disabled={item.disabled}>{item.label}</option>
          ))}
        </select>
        <input
          className='modify_sensor_form_select_with_input-input'
          type='number'
          min={-1}
          max={360}
          {...inputProps}
          onKeyUp={e => {
            const value = Number(e.target.value);
            if (value > 359) setValue(props.inputName, 359);
            if (value < 0) setValue(props.inputName, 0);
          }}
          onChange={e => {
            if (!refDetectModifyDirectionAndRotation.current)
              refDetectModifyDirectionAndRotation.current = true;
            inputOnChange(e); // Call the original onChange
          }}
          step="1"
        />
      </div>
    }
    return <input type={type} {...register(name, { required, valueAsNumber: type === 'number' })} {...props} step={props.step || "any"} />
  }

  const renderError = (item) => {
    // if (!item.required) return null;

    const { name, displayName } = item;
    const isDataField = name.startsWith('data');
    const errorKey = isDataField ? name.substr(5) : name;
    const errorObj = isDataField ? errors?.data?.[errorKey] : errors?.[errorKey];

    if (!errorObj) return null;

    let label;

    if (isDataField) {
      if (name === STORAGE_IMAGE_INTERVAL || name === `${ALARM_VALUE_SIGNAL}4` || name === `${ALARM_RETURN_THRESHOLD_SIGNAL}4` || name === `${CAUTION_VALUE_SIGNAL}4`) {
        label = errorObj.message;
      } else if (targetGroup?.type === SensorType.CAMERA || errorKey === HISTORY_PERIOD) {
        label = `${displayName.text}を設定していません。`;
      } else {
        label = 'パラメーターを設定していません。';
      }
    } else {
      label = `${displayName.text}を設定していません。`;
    }

    return (
      <label key={'error' + name} className='modify_sensor_form_error'>
        {label}
      </label>
    );
  };


  /*** Event Handlers ***/
  const checkDuplicates = (managementId, name) => {
    const duplicates = [];
    const existingSensors = sensors.filter(s => s.id !== initSensor.id);

    const managementIdExists = existingSensors.some(s => s.managementId === managementId);
    const nameExists = existingSensors.some(s => s.name === name);

    if (managementIdExists) duplicates.push('管理番号');
    if (nameExists) duplicates.push('名称');

    return duplicates;
  };

  const validateLatLngRotation = (data) => {
    const trafficVolumeFeature = data.data?.trafficVolumeFeature;
    const typeCamera = data.data?.typeCamera;
    const parsedLat = parseFloat(data.lat);
    const parsedLng = parseFloat(data.lng);
    // Validate lat/lng
    if (isNaN(data.lat) || !isFinite(parsedLat) || isNaN(parsedLat) || parsedLat < SENSOR_MIN_LAT || parsedLat > SENSOR_MAX_LAT) {
      return DIALOG_ERROR_INVALID_LAT;
    }
    if (isNaN(data.lng) || !isFinite(parsedLng) || isNaN(parsedLng) || parsedLng < SENSOR_MIN_LNG || parsedLng > SENSOR_MAX_LNG) {
      return DIALOG_ERROR_INVALID_LNG;
    }
    // Validate camera rotation
    const camera1Rotation = parseFloat(data.data?.camera1Rotation);
    console.log('camera1Rotation', camera1Rotation);
    if (isNaN(camera1Rotation) || !isFinite(camera1Rotation) || camera1Rotation < SCENARIO_MIN_ROTATION || camera1Rotation > SCENARIO_MAX_ROTATION) {
      return `カメラ1方向: ${DIALOG_ERROR_INVALID_ROTATION}`;
    }
    // Validate camera 2 rotation if DOUBLE camera
    if (typeCamera === 'DOUBLE') {
      const camera2Rotation = parseFloat(data.data?.camera2Rotation);
      if (isNaN(camera2Rotation) || !isFinite(camera2Rotation) || camera2Rotation < SCENARIO_MIN_ROTATION || camera2Rotation > SCENARIO_MAX_ROTATION) {
        return `カメラ2方向: ${DIALOG_ERROR_INVALID_ROTATION}`;
      }
    }
    // Validate lat, lng, rotation traffic volume scenarios if trafficVolumeFeature is enabled
    if (trafficVolumeFeature) {
      for (let i = 1; i <= 10; i++) {
        // Validate specific traffic volume scenario is enabled
        if (!data.data?.[`trafficVolumeScenario${i}`]) continue;

        const lat = parseFloat(data.data?.[`trafficVolumeLat${i}`]);
        const lng = parseFloat(data.data?.[`trafficVolumeLng${i}`]);
        const rotation = parseFloat(data.data?.[`trafficVolumeRotation${i}`]);

        if (isNaN(lat) || !isFinite(lat) || lat < SENSOR_MIN_LAT || lat > SENSOR_MAX_LAT) {
          return `シナリオ${i}: ${DIALOG_ERROR_INVALID_LAT}`;
        }
        if (isNaN(lng) || !isFinite(lng) || lng < SENSOR_MIN_LNG || lng > SENSOR_MAX_LNG) {
          return `シナリオ${i}: ${DIALOG_ERROR_INVALID_LNG}`;
        }
        if (isNaN(rotation) || !isFinite(rotation) || rotation < SCENARIO_MIN_ROTATION || rotation > SCENARIO_MAX_ROTATION) {
          return `シナリオ${i}: ${DIALOG_ERROR_INVALID_ROTATION}`;
        }
      }
    }
    return null;
  }

  const onSubmit = async (data) => {
    // Check for duplicates
    const duplicates = checkDuplicates(data.managementId, data.name);
    if (duplicates.length > 0) {
      error(`${duplicates.join('・')}が重複しています`);
      return;
    }
    if (initSensor.id) data.id = initSensor.id;

    const validate = validateLatLngRotation(data);
    if (validate) {
      error(validate);
      return;
    }

    if (targetGroup.type === SensorType.FLOOD_GATE && data.data[MAX_WATER_LEVEL] <= data.data[MIN_WATER_LEVEL]) {
      error(DIALOG_ERROR_INVALID_GRAPH_WATER_LEVEL);
      return;
    }
    if (targetGroup.type === SensorType.FLOOD_GATE && data.data[MAX_OPENING_LEVEL] <= data.data[MIN_OPENING_LEVEL]) {
      error(DIALOG_ERROR_INVALID_GRAPH_GATE_OPENING_LEVEL);
      return;
    }

    data.data = Object.assign(props.sensor.data || {}, data.data)

    if (!initSensor.id) {
      if (targetGroup.type === SensorType.CAMERA) {
        data.id = 'camera';
      } else if (targetGroup.type === SensorType.GENERAL && data.data.connectMethod === "SOCKET") {
        data.id = 'socket';
      }
    }

    onModifySensor(data);
  }

  const onModifySensor = async (newSensor) => {
    if (newSensor.id.toLowerCase() !== newSensor.id) {
      error(DIALOG_ERROR_USE_UPPERCASE_ELTRES_ID);
      return;
    }
    if (loading) return;
    let result
    if (initSensor.id) {
      const currentTimestamp = new Date().toISOString();

      // Check if traffic volume feature changed to update lastTrafficVolumeFeatChanged
      const hasTrafficVolumeFeatureChanges = dirtyFields?.data?.trafficVolumeFeature || dirtyFields?.data?.cameraFeature;
      if (hasTrafficVolumeFeatureChanges) {
        newSensor.data.lastTrafficCountEnabled = currentTimestamp;
      }

      // Check if individual scenarios changed to update lastScenario[N]Enabled
      for (let i = 1; i <= 10; i++) {
        const scenarioFieldName = `trafficVolumeScenario${i}`;
        const lastEnabledFieldName = `lastScenario${i}Enabled`;

        if (dirtyFields.data?.[scenarioFieldName]) {
          newSensor.data[lastEnabledFieldName] = currentTimestamp;
        }
      }

      // Check if camera directions need to be reset
      const hasCameraTypeChanges = dirtyFields.data?.typeCamera;
      const hasCameraDirChanges = dirtyFields.data?.camera1Direction ||
        dirtyFields.data?.camera2Direction;
      const hasDirectionChanges = hasCameraTypeChanges || hasCameraDirChanges

      if (targetGroup?.type === SensorType.CAMERA && hasDirectionChanges) {
        const directions = newSensor.data.typeCamera === "DOUBLE"
          ? [newSensor.data.camera1Direction, newSensor.data.camera2Direction]
          : [newSensor.data.camera1Direction];
        const preMessage = [];
        if (hasCameraTypeChanges) preMessage.push('カメラ区分');
        if (hasCameraDirChanges) preMessage.push('カメラ方向');
        warningConfirm(
          <>
            <div>{`${preMessage.join('・')}が変更されました。`}以下の設定がクリアされます。</div>
            <div>・設置箇所一覧画面 表示パターン名称</div>
          </>,
          async () => {
            setLoading(true);
            await apiResetUserDeviceGroups(newSensor.id, directions);
            const result = await apiUpdateSensor(newSensor);
            setLoading(false);
            reset({
              id: result.data.id?.split('+')[0],
              managementId: result.data.managementId,
              name: result.data.name,
              location: result.data.location,
              groupId: groupId,
              apiGroupId: result.data.apiGroupId,
              lat: result.data.lat,
              lng: result.data.lng,
              description: result.data.description,
              data: JSON.parse(result.data.data || '{}')
            })
            if (result.success) {
              success(DIALOG_MESSAGE_UPDATED_SENSOR_SUCCESSFULLY);
            } else {
              error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
            }
          },
          { width: 'fit-content', cancelText: TEXT_CANCEL, confirmText: TEXT_OK }
        );
        return;
      }

      setLoading(true);
      result = await apiUpdateSensor(newSensor);
    } else {
      setLoading(true);
      setLoading(true);
      result = await apiCreateSensor(newSensor);
    }
    setLoading(false);
    if (result.success) {
      if (initSensor.id) {
        success(DIALOG_MESSAGE_UPDATED_SENSOR_SUCCESSFULLY);
      }
      else {
        success(DIALOG_MESSAGE_CREATED_SENSOR_SUCCESSFULLY);
      }
    }
    else {
      error(result.error === TEXT_ERROR_SENSOR_ALREADY_EXISTED ? TEXT_ERROR_SENSOR_ALREADY_EXISTED : DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
    }
  }

  const shouldRenderItem = (item) => {
    if (item.dependsOn) {
      if (Array.isArray(item.dependsOn)) {
        return item.dependsOn.every(dep => {
          const eqValue = dep.value;
          const neValue = dep.neValue;
          if (eqValue) return watch(dep.name) === eqValue;
          if (neValue) return watch(dep.name) !== neValue;
          return true
        });
      }
      const eqValue = item.dependsOn.value;
      const neValue = item.dependsOn.neValue;
      if (eqValue) return watch(item.dependsOn.name) === eqValue;
      if (neValue) return watch(item.dependsOn.name) !== neValue;
      return true;
    }
    return true;
  };

  /*** Main Render ***/
  return <>
    <form
      className='modify_sensor_form_container'
      onSubmit={handleSubmit(onSubmit)}>
      {FORM_ITEMS.map((item) => {
        if (!shouldRenderItem(item)) return null;
        return <>
          <div
            className='modify_sensor_form_item_line'>
            <label className='modify_sensor_form_item_key'>
              {item.displayName.text}
              {item.type === 'range' ? `(${watch(item.name) || item.min})` : ''}
              {item.displayName.small && <small className='modify_sensor_form_item_key_subtext'> {item.displayName.small}</small>}
              {item.required && <label className='modify_sensor_form_notnull_field'>*</label>}
              {item.isSeparator && item.hasIcon &&
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  className='modify_sensor_form_info_button'
                  onClick={() => { setPropertyDialogOpen(true) }} />}
            </label>
            {renderItemValue(item)}
          </div>
          {/* Error Message */}
          {item.childrens ? item.childrens.map(child => <div key={`error-${child.name}`}>{renderError(child)}</div>) : renderError(item)}
        </>;
      })}
      <div className='modify_sensor_form_buttons_container'>
        <input
          className='modify_sensor_form_button button_active'
          type="submit"
          value={initSensor.id ? TEXT_BUTTON_UPDATE : TEXT_BUTTON_CREATE} />
        <button
          className='modify_sensor_form_button button_cancel'
          type='button'
          onClick={props.onCancel}>
          {TEXT_CANCEL}
        </button>
      </div>
    </form>
    {loading && <div className='modify_sensor_form_loading'><FanLoadingIcon size={80} /></div>}
    {propertyDialogOpen && <SensorPropertyInfoDialog onClose={() => { setPropertyDialogOpen(false) }} />}
  </>
}
ModifySensorForm.propTypes = propTypes;
ModifySensorForm.defaultProps = defaultProps;
export default ModifySensorForm;